export const SET_IS_AUTHORIZED = 'app/core/SET_IS_AUTHORIZED';
